// Docs https://vue-foldable.ulivz.com/#getting-started
import Vue from 'vue'
import VueFoldable from 'vue-foldable'

Vue.component('foldable', VueFoldable)
